<template>
  <div style="margin-left: 2%; margin-right: 2%; margin-top: 1%">
    <div class="not-print mb-4">
      <b-row>
        <b-col class="d-flex flex-column" cols="4">
          <date-input
            alias="Estoque existente em"
            type="date"
            v-model="searchForm.date"
          />
        </b-col>
        <b-col class="d-flex justify-content-between align-items-end">
          <div class="form-group">
            <b-btn @click="select()" class="btn btn-sm" variant="primary">
              <i class="fas fa-search" /> Pesquisar
            </b-btn>
          </div>
          <text-input
            class="ml-auto mr-4"
            v-model="book_number"
            :alias="'Nº. do Livro '"
          />
          <div class="form-group">
            <b-btn variant="primary" class="btn btn-sm" @click="print()">
              <i class="fas fa-print mr-1" /> Imprimir
            </b-btn>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <category-search
            ref="CategorySearch"
            @categorySelected="setCategory($event)"
          />
        </b-col>
        <b-col
          ><select-input
            v-model="searchForm.csosn"
            alias="CSOSN"
            :options="csosn"
          />
        </b-col>
        <b-col
          ><select-input
            v-model="searchForm.classificacao_fiscal"
            alias="Classificação Fiscal"
            :options="classificacaoFiscal"
        /></b-col>
        <b-col
          ><select-input
            v-model="searchForm.origem"
            alias="Origem"
            :options="origens"
        /></b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-checkbox
            v-model="searchForm.product_balance"
            value="inStock"
            unchecked-value="noStock"
          >
            Apenas produtos com estoque positivo
          </b-form-checkbox>
        </b-col>
      </b-row>
    </div>
    <div class="row">
      <div class="col">
        <div class="card">
          <b-table responsive small :items="products" :fields="fields">
            <template #thead-top>
              <b-tr>
                <b-th class="p-0" colspan="8">
                  <b-card style="border: 0px">
                    <template #header>
                      <h4 class="text-center">Inventário de Estoque</h4>
                    </template>

                    <b-row>
                      <b-col>
                        <strong>Razão Social:</strong> {{ company.alias }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="d-flex">
                        <span>
                          <strong>CNPJ: </strong>
                          {{ company.cnpj | VMask("##.###.###/####-##") }}
                        </span>

                        <span class="ml-auto">
                          <strong>Inscrição Estadual: </strong>
                          {{ company.inscricao_estadual }}
                        </span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="8">
                        <div
                          v-if="searchForm.classificacao_fiscal != 'null'"
                          class="d-flex"
                        >
                          <strong class="mr-2"> Classificação Fiscal: </strong
                          >{{
                            classificacaoFiscal[searchForm.classificacao_fiscal]
                          }}
                        </div>

                        <div v-if="searchForm.csosn != 'null'" class="d-flex">
                          <strong class="mr-2"> CSOSN:</strong
                          >{{ csosn[searchForm.csosn] }}
                        </div>
                        <div v-if="searchForm.origem != 'null'" class="d-flex">
                          <strong class="mr-2"> Origem:</strong
                          >{{ origens[searchForm.origem] }}
                        </div>
                      </b-col>
                      <b-col class="text-right">
                        <span class="font-weight-bold"
                          >Estoque existente em
                          {{ searchForm.date | dateBr }}</span
                        >
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-right">
                        <span class="font-weight-bold"
                          >Total Geral de {{ stock_total | moneyBr }}</span
                        >
                        <br />
                        <span v-if="book_number" class="text-right"
                          >Nº. do Livro : {{ book_number }}</span
                        >
                      </b-col>
                    </b-row>
                  </b-card>
                </b-th>
              </b-tr>
            </template>
            <template #cell(balance)="data">
              {{ data.item.balance | decimal }}
            </template>
            <template #cell(cost)="data">
              {{ data.item.company_cost | moneyBr }}
            </template>
            <template #cell(product_total)="data">
              {{ data.item.product_total | moneyBr }}
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import csosn from "@/enums/csosn";
import classificacaoFiscal from "@/enums/classificacaoFiscal";
import origens from "@/enums/origens";
import CategorySearch from "@/components/CategorySearch";

export default {
  components: {
    CategorySearch,
  },
  data() {
    return {
      csosn: csosn,
      classificacaoFiscal: classificacaoFiscal,
      origens: origens,

      book_number: null,

      fields: [
        { key: "base_sku_id", label: "Código", class: "text-center" },
        {
          key: "ncm",
          label: "NCM",
          class: "text-center",
        },
        { key: "description", label: "Descrição", class: "text-center" },
        { key: "unit", label: "Un.", class: "text-center" },
        { key: "balance", label: "Estoque", class: "text-center  " },
        { key: "cost", label: "Valor Unitário", class: "text-center" },
        {
          key: "product_total",
          label: "Valor Total",
          class: "text-center",
        },
      ],
      searchForm: {
        date: moment().format("Y-MM-D"),
        product_balance: "inStock",
        classificacao_fiscal: "null",
        csosn: "null",
        origem: "null",
        category_id: null,
        category_description: null,
      },
      products: [],
      stock_total: null,
      error: {},
    };
  },
  created() {
    // this.select();
    this.$store.commit("pageHasLoaded");
  },
  computed: {
    company() {
      return this.$store.state.company;
    },
  },

  methods: {
    select() {
      this.$store.commit("showLoading");

      this.$store
        .dispatch("products/getStockAudit", this.searchForm)
        .then((response) => {
          this.products = Object.values(response.data.stock_audit);
          this.stock_total = response.data.stock_total;
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.error = error;
          this.$store.commit("hideLoading");
        });
    },

    print() {
      window.print();
    },

    setCategory(category) {
      this.searchForm.category_id = category.id;
      this.searchForm.category_description = category.description;
    },
  },
};
</script>


<style scoped>
@media print {
  .not-print {
    display: none;
  }
}
</style>
